module.exports = __webpack_public_path__ + "static/media/portillos.28c426bc.png";